import { render, staticRenderFns } from "./AddressForm.vue?vue&type=template&id=2c2bd3cb&scoped=true&"
import script from "./AddressForm.vue?vue&type=script&lang=js&"
export * from "./AddressForm.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/forms.css?vue&type=style&index=0&id=2c2bd3cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2bd3cb",
  null
  
)

export default component.exports